import {useContext} from "react";
import useHandleOnDrop from "./useHandleOnDrop";
import useGetApiData from "./useGetApiData.js";
import useGetValueFromArray from "./useGetValueFromArray.js";
import useGetCurrentsTools from "./useGetCurrentsTools.js";
import { store } from "../store.js";

const useSetRowData = () => {
  const handleOnDrop = useHandleOnDrop();
  const getValueFromArray = useGetValueFromArray();
  const getApiData = useGetApiData();
  const getCurrentsTools = useGetCurrentsTools();
  const globalState = useContext(store);

  const getAllData = (formData) => {
    
    return [formData.data, ...(formData.apiData ? formData.apiData : []) ]
  }
  const setRowData = (control, pagination) => {
    var formData = JSON.parse(JSON.stringify(globalState.state.formData))
    const currentMapping = getMappingByControl(control)
    
    if (currentMapping) { //if (currentMapping && currentMapping.value[0] == apiId) {
      const mappingId =currentMapping.value[0]
      
      if (!mappingId) return []

      var currentData = [formData.data].filter(item => item.globalId == mappingId)[0]
      var isFormData = currentData != undefined

      if (!isFormData)
        currentData = mappingId && getAllData(formData).filter(item => item.globalId == mappingId)[0]

      const apiData = currentData && currentData.data
      
      if (!apiData) return []
      
      const dataSourcePath = currentMapping.value
      const pathName = getValueFromArray(dataSourcePath).name
      let pathNames =  pathName.split(".")
      pathNames = pathNames.slice(isFormData ? 0 : 1, pathNames.length) //pathNames.slice(1, pathNames.length)
          
      var data = getApiData(pathNames, apiData)
      
      switch (control.type) {
        case "DataGrid":
          control.metaData.filter(item => item.type == "Row").metaData = []
          var rows = control.metaData.filter(item => item.type == "Rows")[0]
          
          rows = JSON.parse(JSON.stringify(rows))
          rows.metaData.forEach(col => {
            var value = col.properties.text.value
            if (typeof value == "object") {
              
              if (Array.isArray(value.id)) {
                let pathid = undefined
                const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId + "_id")[0]
                pathid = detail && detail.value.value
                if (pathid && Array.isArray(pathid)) {
                  col.properties.text.value.id = getValueFromArray(pathid, undefined, dataSourcePath ).name
                  col.properties.text.isArray = true
                }
              }
              if (Array.isArray(value.item)) {
                let pathid = undefined
                const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId + "_item")[0]
                pathid = detail && detail.value.value
                if (pathid && Array.isArray(pathid)) {
                  col.properties.text.value.item = getValueFromArray(pathid, undefined, dataSourcePath ).name
                  col.properties.text.isArray = true
                }
              }
              if (Array.isArray(value.value)) {
                let pathid = undefined
                const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId + "_value")[0]
                pathid = detail && detail.value.value
                if (pathid && Array.isArray(pathid)) {
                  col.properties.text.value.value = getValueFromArray(pathid, undefined, dataSourcePath ).name
                  col.properties.text.isArray = true
                }
              }
            }
            else{
              let pathid = undefined
              const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId)[0]
              pathid = detail && detail.value.value
              if (pathid && Array.isArray(pathid)) {
                col.properties.text.value = getValueFromArray(pathid, undefined, dataSourcePath ).name
                col.properties.text.isArray = true
              }
            }
           
            if (col.type == "ListBox" || col.type == "AutoComplete") 
            setRowData(col, pagination) //setRowData(col, apiId, apiData, formData)
            
          })
          var nRow = 4 // SearchBar + Headerbar + FilterBar + Rows
        
          const isArray = Array.isArray(data)
          
          if (isArray) {
            if (pagination.operations.length != 0)
              data = data.filter((lineData, index) => isValidLine(rows.metaData, lineData, pagination, index))
            if (pagination.orderedColType) {
              const colName = Array.isArray(pagination.orderedColValue) 
              ? getValueFromArray(pagination.orderedColValue).name 
              : undefined   
              if(colName)
                data.sort((a,b) => a[colName] > b[colName] ? 
                  (pagination.orderedColType == "asc" ? 1 : -1) : (pagination.orderedColType == "asc" ? -1 : 1)
                )
            }
            data.slice(pagination.start -1, pagination.end).forEach((lineData, i) => {
              var newRow =  JSON.parse(JSON.stringify(rows))
              newRow.type = "Row"
              nRow = nRow + i  
              newRow.metaData.forEach((col, index) => {
              var value = col.properties.text.value
              if (typeof value == "object") {
                  col.properties.text.value.id = value.id && value.id != "" ? getApiData(value.id.split("."), lineData, index) 
                  : (typeof lineData == "object" ? "" : lineData)
                  col.properties.text.value.item = value.item && value.item != "" ? getApiData(value.item.split("."), lineData, index) 
                  : (typeof lineData == "object" ? "" : lineData)
              }
              else{
                  col.properties.text.value = value && value != "" ? getApiData(value.split("."), lineData, index) 
                  : (typeof lineData == "object" ? "" : lineData)
              }
              })

           
              handleOnDrop(formData, {id:[control.id, ...control.parentId], globalId:[control.globalId, ...control.parentGlobalId]}
              , {...newRow, id:0}, {type:"Row", gridSettingsId:control.globalId, index:nRow})
            
            })
          }
          //control.properties.actualize.value = false
          var currentsTools = []
          getCurrentsTools(formData, currentsTools, [control.id]);
          
          return currentsTools[0].metaData.filter(item => item.type == "Row");
          
        case "ListBox":
        case "AutoComplete":
          var value = {id:"", item:""} 

          let pathId = undefined
          let detail = currentMapping.details.filter(item => item.key.value.slice(-1) == control.globalId + "_id")[0]
          pathId = detail && detail.value.value
          if (pathId && Array.isArray(pathId)) 
            value.id = getValueFromArray(pathId, undefined, dataSourcePath ).name
          
          //let pathid = undefined
          detail = currentMapping.details.filter(item => item.key.value.slice(-1) == control.globalId + "_item")[0]
          pathId = detail && detail.value.value
          if (pathId && Array.isArray(pathId)) 
            value.item = getValueFromArray(pathId, undefined, dataSourcePath ).name
          
          detail = currentMapping.details.filter(item => item.key.value.slice(-1) == control.globalId + "_value")[0]
          pathId = detail && detail.value.value
          if (pathId && Array.isArray(pathId)) 
            value.value = getValueFromArray(pathId, undefined, dataSourcePath ).name

          
          
          control.properties.data.value.mapping.data = []
          Array.isArray(data) && data.forEach((lineData, index) => {
            var newItem = JSON.parse(JSON.stringify(value))
            newItem.id = value.id && value.id != "" ? getApiData(value.id.split("."), lineData, index) 
            : (typeof lineData == "object" ? "" : lineData)
            newItem.item = value.item && value.item != "" ? getApiData(value.item.split("."), lineData, index) 
            : (typeof lineData == "object" ? "" : lineData)
            newItem.value = value.value && value.value != "" ? getApiData(value.value.split("."), lineData, index) 
            : (typeof lineData == "object" ? "" : lineData)
            control.properties.data.value.mapping.data.push(newItem)
          });
          
          return control.properties.data.value.mapping.data
      
      } 
    } else return []
    
  };

  const getMappingByControl = (control) => { 
   
    if(control.properties.data && control.properties.data.option.toLowerCase() == "mapping"){
      
      return control.properties.data.value.mapping.values
              .filter(item => item.id == control.properties.data.value.mapping.id)[0]
    }
    return undefined
    
  }

  const isConditionChecked = (firstOperand, operator, secondOperand) => {

    switch (operator) {
      case "equal":
        return firstOperand == secondOperand
      case "not equal":
        return firstOperand != secondOperand
      case "greater":
        return firstOperand > secondOperand
      case "greater & equal":
        return firstOperand >= secondOperand
      case "lower":
        return firstOperand < secondOperand
      case "lower & equal":
        return firstOperand <= secondOperand
      case "contains":
        return firstOperand.includes(secondOperand)
      case "starts with":
        return firstOperand.startsWith(secondOperand)
      case "ends with":
        return firstOperand.endsWith(secondOperand)
    }
  };
  
  const isValidLine = (currentRow, lineData, pagination, index) => {

    var isValid = true
    var n = currentRow.length
    var i = 0
    
    while (isValid && i < n) {
      let currentCol = currentRow[i]
      
      if (pagination.filteredColId.includes(currentCol.headerId)) {
        const currentOperation = pagination.operations.filter(operation => operation.firstOperand.headerId == currentCol.headerId)[0]
        var value = currentCol.properties.text.value
        var isArray = currentCol.properties.text.isArray
        
        if (typeof value == "object") value = value.item
        
        let operator = currentOperation.operator.item
        let filteredCol = pagination.filterData.metaData.filter(item => item.id == currentOperation.colId)[0]
      
        let firstOperand = Array.isArray(value) || isArray ? getApiData(value.split("."), lineData, index) : value //currentCol.properties.text.value
        let secondOperand = filteredCol.properties.text.value
       
        //firstOperand = typeof firstOperand == 'object' ? firstOperand.item : firstOperand //JSON.stringify(firstOperand)
        secondOperand = typeof secondOperand == 'object' ? secondOperand.item : secondOperand //JSON.stringify(secondOperand)

        isValid = isConditionChecked(firstOperand, operator, secondOperand)
      }
      i = i + 1
    }
    
    
   return isValid
  };
  return setRowData;
};

export default useSetRowData;
